import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../services/user.service";
import { ReportService } from "../services/report.service";
import { PagerserviceService } from "../services/pagerservice.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-referralbonustrans',
  templateUrl: './referralbonustrans.component.html',
  styleUrls: ['./referralbonustrans.component.css']
})
export class ReferralbonustransComponent implements OnInit {

  displayedColumns = [
    'tradeid' ,
    'user_name',
    'referal_user',
    'amount' ,
    'currency' ,
    'marekt_price',
    'description' ,
    'createdAt',
  ];

  filter: any = {
    fDate: moment().format('yyyy-MM-DD'),
    tDate: moment().format('yyyy-MM-DD')
  };
  dataSource: MatTableDataSource<any>;
  pageSize = 25;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  permission: String;

  constructor(private notifSer: NotificationsService,
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router, 
    private reportService: ReportService, 
    private notif: NotificationsService) { }

  ngOnInit() {
    if (!this.userService.isLoggedIn()) {
      this.router.navigateByUrl('/index');
    } else {
      if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
        var spt = this.router.url.split("/");
        var menu_url = spt[1];
        var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
        var adminrules = JSON.parse(localStorage.getItem('adminrules'));
        var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
        if (index != -1) {
          var menuid = adminmenus[index]._id;
          var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
          this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
        }
      }
    }
    this.csrf();
  }
  csrf() {
    this.userService.csrf().subscribe((success) => {
      this.filter._csrf = success._csrf;

      this.getBonustrans();
    }, (error) => {
      if (error.status > 0) {
        this.notif.error(
          'CSRF',
          error.error.message,
          {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          }
        )
      }
    })
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    console.log(event.value)
    this.filter['fDate'] = moment(event.value).format('yyyy-MM-DD');
  }
  async toDateFilter(event: MatDatepickerInputEvent<Date>) {
    this.filter['tDate'] = moment(event.value).format('yyyy-MM-DD');
  }
  applyFilter(filterValue: string) {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
      this.dataSource.filter = filterValue;
  }

  getBonustrans() {
    this.reportService.getBonustrans(this.filter).subscribe((success) => {
      if (success.status) {
        this.dataSource = new MatTableDataSource(success.bonus);
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.sort;
      }
    });
  }

  exportExcel(ref: string) {
    this.reportService.getBonustrans(this.filter).subscribe((success) => {
      if (success.status) {
      let exportreflist = [];
        for (let i = 0; i < success.bonus.length; i++) {
          exportreflist.push({
            'Trade Id': success.bonus[i].tradeid,
            'User Name': success.bonus[i].user_name,
            'Referal User': success.bonus[i].referal_user,
            'Amount': success.bonus[i].amount,
            'Currency': success.bonus[i].currency,
            'Marekt Price': success.bonus[i].marekt_price,
            'Description': success.bonus[i].description,
            'CreatedAt': success.bonus[i].createdAt,
          })
        }
        let fileName = 'ReferralBonusReport.xlsx';
        console.log(exportreflist)
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportreflist);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        /* save to file */
        XLSX.writeFile(wb, fileName);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/referralbonustrans/referralbonustrans.component.ts